"use strict";

import {
    authConstants,
    commonConstants,
    responseCodes,
    participantJobRoleIds,
} from "../_constants";

export const INITIAL_AUTH_STATE = {
    userProfileDetails: {},
    userPrePasswordChangeData: null,
    userPreMobileDetails: null,
    dealerships: null,
};

export function auth(state = INITIAL_AUTH_STATE, action) {
    switch (action.type) {
        /**
         * Customer account actication
         */
        case authConstants.PRE_REGISTRATION_ACTIVATE_REQUEST:
            if (!action.payload.validateOtp) {
                return {
                    ...state,
                    userProfileDetails: {
                        ...action.payload,
                    },
                };
            }

            return {
                ...state,
            };

        case authConstants.PRE_REGISTRATION_ACTIVATE_COMPLETE:
            return {
                ...state,
            };

        /**
         * End Customer account actication
         */
        /**
         * Customer forgot password
         */
        case authConstants.FORGOT_PASSWORD_RESET_PASSWORD_REQUEST:
            if (!action.payload.validateOtp) {
                return {
                    ...state,
                    userProfileDetails: {
                        userId: action.payload.userId,
                        confirmPassword: action.payload.confirmPassword,
                        newPassword: action.payload.newPassword,
                        authToken: action.payload.authToken,
                    },
                };
            }

            return {
                ...state,
            };

        case authConstants.FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE:
            return {
                ...state,
            };

        /**
         * End Customer forgot password
         */

        /**
         * Customer login
         */

        case authConstants.AUTH_LOGIN_REQUEST:
            if (!action.payload.validateOtp) {
                return {
                    ...state,
                    userProfileDetails: {
                        email: action.payload.email,
                        password: action.payload.password,
                    },
                };
            }

            return {
                ...state,
            };

        case authConstants.AUTH_LOGIN_COMPLETE:
            return {
                ...state,
            };

        case authConstants.AUTH_USER_PROFILE_DEATAILS_COMPLETE:
            return {
                ...state,
                userProfileDetails: { ...action.payload.data },
            };

        case authConstants.PRE_REGISTRATION_COMPLETE:
            return {
                ...state,
                userProfileDetails: { ...action.payload.data },
            };
        case authConstants.AUTH_CHANGE_PASSWORD_PRE_AUTH_DETAILS:
            return {
                ...state,
                userPrePasswordChangeData: action.payload,
            };
        case authConstants.AUTH_CHANGE_MOBILE_NUMBER_PRE_MOBILE_DETAILS:
            return {
                ...state,
                userPreMobileDetails: action.payload,
            };
        case authConstants.AUTH_CHANGE_PASSWORD_COMPLETE:
            return {
                ...state,
                userPrePasswordChangeData: null,
            };
        case authConstants.AUTH_CHANGE_MOBILE_NUMBER_COMPLETE:
            return {
                ...state,
                userPreMobileDetails: null,
            };
        case authConstants.AUTH_GET_PARTICIPANT_PROFILE_COMPLETE:
            if (
                action?.payload?.data?.jobRoleId !==
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER
            ) {
                return {
                    ...state,
                    userProfileDetails: { ...action.payload.data },
                    dealerships: { ...action.payload.data.dealerships[0] },
                };
            } else if (action.payload.data.dealerships.length === 1) {
                return {
                    ...state,
                    userProfileDetails: { ...action.payload.data },
                    dealerships: { ...action.payload.data.dealerships[0] },
                };
            } else {
                return {
                    ...state,
                    userProfileDetails: { ...action.payload.data },
                };
            }
        case authConstants.AUTH_SELECT_DEALER_SHIP:
            return {
                ...state,
                dealerships: { ...action.payload },
            };

        // case commonConstants.AJAX_ERROR:
        //     return INITIAL_AUTH_STATE;febaUserName
    }

    return state;
}
